<template>
    <!-- Liste des réponses -->
    <div id="row-reponse-qcm" v-if="qcm_list_reponses.length">
        <!-- Formulaires pour les réponses QCM non-validation -->
        <form
            v-for="reponse in qcm_list_reponses"
            :key="reponse.id_reponse"
            :id="'form-reponse-qcm-' + reponse.id_reponse"
            :class="[
                'form-reponse-qcm',
                'form-notification-' + reponse.id_reponse,
                reponse.parametres?.class ?? ''
            ]"
            @submit.prevent=""
        >
            <!-- CSRF token field (injected dynamically) -->
            <input type="hidden" :value='this.csrfTokenValue' :name="this.csrfTokenName">
            <input
                id="input-id-parent"
                type="hidden"
                name="id_parent"
                :value="reponse.id_reponse"
            />
        
            <!-- Bouton réponses pour QCM (sélectionnable) -->
            <button
                :id="'button-' + reponse.id_reponse"
                :data-id="reponse.id_reponse"
                class="reponse-qcm w-100"
                :class="{ 'selected': reponse.selected }"
                type="button"
                @click="toggle_reponse_selection( reponse, $event )"
            >
                {{ reponse.texte }}
            </button>
        </form>
    </div>
    
    <div id="reponse-validation" v-if="qcm_list_reponses.length">
        <!-- Formulaire pour la réponse de validation QCM -->
        <form
            v-if="validation_qcm_reponse"
            :key="validation_qcm_reponse.id_reponse"
            :id="'form-reponse-validation-' + validation_qcm_reponse.id_reponse"
            :class="[
                'form-reponse-validation',
                'form-notification-' + validation_qcm_reponse.id_reponse,
                validation_qcm_reponse.parametres?.class ?? ''
            ]"
            @submit.prevent=""
        >
            <!-- CSRF token field (injected dynamically) -->
            <input
                id="input-id-parent"
                type="hidden"
                name="id_parent"
                :value="validation_qcm_reponse.id_reponse"
            />
    
        <!-- Bouton de validation pour QCM -->
            <button
                type="button"
                class="validate"
                @click="validate_reponses( validation_qcm_reponse, $event )"
            >
                {{ validation_qcm_reponse.texte }}
            </button>
        </form>
    </div>
</template>
  
<script>
    export default {
        name: "ReponseQCMComponent",
        props: {
            list_reponses: {
                type: Array,
                default: () => [],
            },
            csrfTokenName: {
                type: String,
                required: true
            },
            csrfTokenValue: {
                type: String,
                required: true
            },
            selected_reponses: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
            };
        },
        computed: {
            // Filtrer les réponses pour exclure celles de type 'validation_qcm'
            qcm_list_reponses() {
                return this.list_reponses.filter(
                    ( reponse ) => reponse.type !== "validation_qcm"
                );
            },
            // Trouver la réponse de type 'validation_qcm'
            validation_qcm_reponse() {
                return this.list_reponses.find(
                    ( reponse ) => reponse.type === "validation_qcm"
                );
            },
        },
        methods: {
            // Fonction pour basculer la sélection d'une réponse
            toggle_reponse_selection( reponse, event ) {
                // Afficher l'objet reponse dans la console
                const button = event.target;
                reponse.selected = !reponse.selected;
                button.classList.toggle( "selected", reponse.selected );
            },
            // Fonction pour valider les réponses sélectionnées
            validate_reponses( reponse, event ) {
                // Sélectionner tous les éléments avec la classe 'selected'
                var selected_reponses = document.querySelectorAll( ".reponse-qcm.selected" );
        
                // Créer un tableau pour stocker les IDs des réponses sélectionnées
                var selected_reponses_ids = [];
        
                // Parcourir chaque réponse sélectionnée
                selected_reponses.forEach(function ( reponse ) {
                    // Obtenir l'ID de la réponse
                    var id = reponse.getAttribute( "data-id" );
            
                    // Ajouter l'ID au tableau
                    selected_reponses_ids.push( id );
                });
        
                // Ajouter l'ID de la réponse de validation
                selected_reponses_ids.push( reponse.id_reponse );
        
                // Envoyer la liste des réponses sélectionnées via AJAX
                this.submit_list_reponses( selected_reponses_ids, event );
            },
            // Soumettre la liste des réponses sélectionnées
            submit_list_reponses( list_reponses, event ) {
                window.ajax_traitement_list_reponses( list_reponses, "reponse", false, event );
            },
        },
    };
</script>